import type { FaireProductEntity } from "../../entity_types/product";

export const p_grg3crbvvr: FaireProductEntity = {
  token: "p_grg3crbvvr",
  type: "product",
  name: "15x42 Meadowlark Pillow, Grey Blue",
  brandToken: "b_6jjy4txuzi",
  brandName: "Indaba Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/bcf742a6dd1f04d0e154bb60d9ff817051ada1e475092658270ac172fe9c79ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3106b3360f28f05d51f992a2134851d0344e22c218c579e5d02fdb220b2a8bfc.jpeg",
    "https://cdn.faire.com/fastly/6eb7f85ef16fa882d858847bf035ae00222bf4459b1a224f34f54ce123ebfc89.jpeg",
    "https://cdn.faire.com/fastly/c1f2cb8fd31d752e447842fcfd04d968f5303c67d92343cec212a7bd6bed18fe.jpeg",
  ],
  priceDollars: 45.6,
  description:
    "15x42 Meadowlark Pillow, Grey Blue, A Long Lumbar Accent Pillow for Serene Styling. Create a calming focal point with the Meadowlark Pillow in Grey Blue.",
  tags: [],
  isNew: true,
  msrpDollars: 91.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
